<script lang="ts">
    import {dyData} from 'general/store';
    import type {DyResponsePopupTextType} from 'types/dy';

    import s from './style.module.css';

    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';
    export let template = 'circle';
    export let padding = '0';

    const value: DyResponsePopupTextType = $dyData.policy[side] || {};
    const defaultMarginTop = value.marginTop || '0';
    const mediaMarginTop = value.mediaValues?.maxHeightXS?.marginTop || defaultMarginTop;
    let innerHeight;
    let marginTop = defaultMarginTop;
    $: if (innerHeight) {
        marginTop = innerHeight > 694 ? defaultMarginTop : mediaMarginTop;
    }
</script>

<svelte:window bind:innerHeight />

{#if value}
    <p
        class="{s.policy} {s[side] || ''} {s[template] || ''}"
        style="
        margin-top: {marginTop};
        margin-bottom: {value.marginBottom || '0'};
        padding: {padding};
        font-size: {value.fontSize || '10px'};
        font-weight: {value.fontWeight || '300'};
        line-height: {value.lineHeight || '1.25'};
        letter-spacing: {value.letterSpacing || '0'};
        text-decoration: {value.textDecoration || 'none'};
        color: {value.color || 'inherit'};
        background-color: {value.backgroundColor || 'none'};
        border-radius: {value.borderRadius || 'none'};
        margin-left: {value.marginLeft || '0'};
        margin-right: {value.marginRight || '0'};"
    >
        {#if value.html} {@html value.html} {:else} {value.text}{/if}
    </p>
{/if}
